import { LoginService } from './../../service/login.service';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
addForm:FormGroup;
password1:string;
password2:string;msg:string="Please Enter Valid phone No";
  constructor(private route:Router,private ApiService:LoginService, private fb:FormBuilder) {  this.addForm=fb.group({
    'password1':[null,Validators.compose([Validators.required,Validators.minLength(10),Validators.maxLength(40)])],
    'password2':[null,Validators.compose([Validators.required,Validators.minLength(10),Validators.maxLength(40)])]
  })}

  ngOnInit(): void {
  }
  reset()
  {
    this.route.navigateByUrl('');
    console.log(localStorage.getItem('idr'));
  }
  verify(v)
  {
    const id1=localStorage.getItem('idr');
    if(v.password1==v.password2)
    {
    const data={
      "id":id1,
      "password":v.password1
    }
    console.log(data)
    this.ApiService.resetPassword(data).then(
      (noerror)=>
      {
        this.route.navigateByUrl('/')
      }
    )
    console.log(v.password1)
    }
    else
    {
      console.log("password is not equal");
    }
  }
}
